import { useMutation } from "@tanstack/react-query";
import apiInputService from "services/apiInputService";

const sendTicket = async (formData: FormData) => {
  const { data } = await apiInputService.post("/ticket", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return data;
};

export const useSendTicket = (options?: any) => {
  return useMutation(sendTicket, {
    ...options,
  });
};
